import React from 'react';

// 1180px content container with 24px gutters.
export function Container({ children, className = '' }) {
  return (
    <div className={`mx-auto w-full max-w-container px-6 ${className}`}>
      {children}
    </div>
  );
}

export default Container;
